import { createAction } from "@reduxjs/toolkit";
import {ChartEntry, PoolV3Data} from "~/state/clpools/types";
import {ProtocolData} from "~/state/info/types";

export const updateUserDataLoaded = createAction<boolean>('clpools/protocol/updateUserDataLoaded')

export const updateProtocolV3Data = createAction<{ protocolData: ProtocolData }>('clpools/protocol/updateProtocolData')
export const updateProtocolV3ChartData = createAction<{ chartData: ChartEntry[] }>(
  'clpools/protocol/updateProtocolChartData',
)

export const updatePoolV3ChartData = createAction<{ poolAddress: string; chartData: ChartEntry[] }>(
    'clpools/pools/updatePoolChartData',)

export const updatePoolV3Data = createAction<{ pools: PoolV3Data[] }>('clpools/pools/updatePoolV3Data')
export const purgeUserData = createAction<{ chainId: number}>('clpools/pools/purgeUserData')

export const resetPoolsFeeData = createAction<{ }>('clpools/pools/resetPoolsFeeData')

